// src/cmps/UserProfile/UserWatchlist/WatchlistFilter.jsx
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { getAnimeDetailsUrl } from '../../../services/util.service'
import { SearchIconInput, DotsFilter, RandomIconInput } from '../../ui/icons/user'

export function WatchlistFilter({
  filterText,
  setFilterText,
  filterStatus,
  setFilterStatus,
  watchlist = [],
  statuses = [],
}) {
  /* counts for each status + total */
  const statusCounts = useMemo(() => {
    const counts = Object.fromEntries(statuses.map(({ value }) => [value, 0]))
    watchlist.forEach(({ status }) => {
      if (counts[status] !== undefined) counts[status]++
    })
    return { all: watchlist.length, ...counts }
  }, [watchlist, statuses])

  const randomAnime = watchlist.length
    ? watchlist[Math.floor(Math.random() * watchlist.length)]
    : null

  return (
    <aside className="sticky top-28" aria-label="סינון וצפייה ברשימת אנימה">
      <div className="flex flex-col w-[220px] gap-5 lg:mt-0 mt-[-100px]">
        {/* header */}
        <header className="flex w-full justify-between items-center">
          <h5 className="font-semibold text-white">סינון אנימות</h5>
          <DotsFilter aria-hidden="true" />
        </header>

        {/* 'all' row */}
        <button
          type="button"
          title="הצג את כל האנימות ברשימה"
          aria-label="הצג הכל"
          onClick={() => setFilterStatus('')}
          className={`flex w-full justify-between items-center transition hover:text-primary ${
            filterStatus === '' ? 'text-primary' : 'text-softText'
          }`}
        >
          <span>הכל</span>
          <span>{statusCounts.all}</span>
        </button>
        <hr className="border-t border-white/15" />

        {/* other statuses */}
        {statuses.map(({ value, label }) => (
          <div key={value}>
            <button
              type="button"
              title={`הצג סטטוס «${label}»`}
              aria-label={`הצג ${label}`}
              onClick={() => setFilterStatus(value)}
              className={`flex w-full mb-2 justify-between items-center transition hover:text-primary ${
                filterStatus === value ? 'text-primary' : 'text-softText'
              }`}
            >
              <span>{label}</span>
              <span>{statusCounts[value] ?? 0}</span>
            </button>
            <hr className="border-t border-white/15" />
          </div>
        ))}

        {/* search + random */}
        <div className="flex flex-col gap-5">
          <label className="sr-only" htmlFor="watch-filter-input">
            חיפוש ברשימה
          </label>
          <div className="flex w-full items-center gap-2 px-3 py-2 border border-softText">
            <input
              id="watch-filter-input"
              type="search"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              placeholder="חפש ברשימה"
              aria-label="חיפוש אנימה ברשימה"
              className="flex-grow bg-transparent outline-none text-sm placeholder:text-softText"
            />
            <SearchIconInput aria-hidden="true" />
          </div>

          {randomAnime && (
            <Link
              to={getAnimeDetailsUrl(randomAnime)}
              title="בחירת אנימה אקראית"
              aria-label="בחירת אנימה אקראית"
              className="flex w-full items-center justify-between px-3 py-2 bg-accent text-white hover:bg-primary transition"
            >
              <span>אנימה אקראית</span>
              <RandomIconInput aria-hidden="true" />
            </Link>
          )}
        </div>
      </div>
    </aside>
  )
}
